import React from "react";
import moment from "moment";
import { Table, Tag } from "antd";
import { LinkOutlined } from "@ant-design/icons";

const DETAILS_CELL_STYLE = {
  maxWidth: 480,
  maxHeight: 120,
  overflowY: "auto",
  whiteSpace: "normal",
  wordBreak: "break-word",
};

// A job's `status` field doubles as free-form progress/error text (no separate error field
// on AdminJob), so split it here into a short badge + the full text for its own column.
const parseStatus = (status) => {
  if (!status) return { label: "-", color: undefined, detail: null };

  if (status === "DONE") return { label: "DONE", color: "success", detail: null };

  if (status.startsWith("FAILED")) {
    return { label: "FAILED", color: "error", detail: status.slice("FAILED".length).replace(/^:\s*/, "") };
  }

  return { label: "PROCESSING", color: "processing", detail: status };
};

const renderStatus = (status) => {
  const { label, color } = parseStatus(status);
  return color ? <Tag color={color}>{label}</Tag> : label;
};

const renderDetails = (status) => {
  const { detail } = parseStatus(status);
  if (!detail) return "-";

  const lines = detail.split("\n");
  const bulletLines = lines.filter((line) => line.startsWith("- "));
  if (!bulletLines.length) {
    return <div style={DETAILS_CELL_STYLE}>{detail}</div>;
  }

  const headerLine = lines[0];
  const expectedLine = lines.find((line) => line.startsWith("Expected"));

  return (
    <div style={DETAILS_CELL_STYLE}>
      <div>{headerLine}</div>
      <ul style={{ margin: "2px 0", paddingLeft: 18 }}>
        {bulletLines.map((line) => (
          <li key={line}>{line.slice(2)}</li>
        ))}
      </ul>
      {expectedLine && <div style={{ color: "rgba(0, 0, 0, 0.45)" }}>{expectedLine}</div>}
    </div>
  );
};

const AdminJobList = (props) => {
  const columns = [
    { title: "Job", dataIndex: ["title"] },
    { title: "Status", key: "status", dataIndex: ["status"], render: renderStatus },
    { title: "Details", key: "details", dataIndex: ["status"], render: renderDetails },
    {
      title: "Launched At",
      dataIndex: "createdAt",
      render: (createdAt) => (createdAt ? moment(createdAt).fromNow() : "-"),
    },
    {
      title: "Last Progress At",
      dataIndex: "updatedAt",
      render: (updatedAt) => (updatedAt ? moment(updatedAt).fromNow() : "-"),
    },
    {
      title: "Result",
      dataIndex: "link",
      render: (link) =>
        link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <LinkOutlined />
          </a>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <div className="table">
      <Table
        rowKey="objectId"
        className="table-section"
        columns={columns}
        dataSource={props.adminJobs}
        pagination={false}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default AdminJobList;
